import {
  WHEEL_ALL,
  WHEEL_GET,
  WHEEL_POST,
  WHEEL_PUT,
  WHEEL_DELETE,
  WHEEL_LOADING,
  WHEEL_ERROR,
  WHEEL_RESET,
} from '../../actions/types';

const initialState = {
  wheel: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WHEEL_LOADING:
      return { isLoading: true, isCompleted: false };
    case WHEEL_ERROR:
      return { isLoading: false, isCompleted: false };
    case WHEEL_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_POST:
      return { isLoading: false, isCompleted: true };
    case WHEEL_PUT:
      return { isLoading: false, isCompleted: true };
    case WHEEL_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
